
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  import {
    orderInvoiceorderInvoiceDetailList
  } from "@/api/finance"
	import {
		handleClipboard
	} from '@/utils/clipboard'
  @Component({  
    name: '',
    components: {
      PageFooter
    }
  })

  export default class ProductList extends Vue {
    private info:any = {}
    private pageloading = false
    private success = 'https://cdn2024.routuan.com/routuanapp/success-icon.png'
    private notInvoiced = 'http://routuan2022.oss-cn-hangzhou.aliyuncs.com/routuan/image/8cecee1e72555e217f8b2afd8a3467b.png'

    private mounted () {
      this.getInfo()
    }

    
    private tocopy(e,row){
      let text = ''
      text += '发票抬头：' + row.RecipientName +'\n'
      text += '税号：' + row.VATNumber  +'\n'
      text += '公司地址：' + row.CompanyAddress  +'\n'
      text += '公司电话：' + row.CompanyPhone  +'\n'
      text += '开户行：' + row.BankName + row.BranchName  +'\n'
      text += '银行账号；' + row.BankAccountNumber  +'\n'
      text += '开票金额：' + row.ProductInvoiceMoney  +'\n'
      text += '订单编号：' + row.OrderNo  +'\n'
      text += '下单人：' + row.WxNickname  +'\n'
      text += '下单时间：' + row.AddTime  +'\n'
      text += '商品明细：' + row.ProductName + '*' + row.ProductCount  +'\n'
      text += '供应商：' + row.CompanyName  +'\n'
      text += '开票状态：' + row.InvoiceStateValue  +'\n'
      
      handleClipboard(text,e)
    }
    private async getInfo(){
      try{
        this.pageloading = true
        let res:any = await orderInvoiceorderInvoiceDetailList({
          Keywords:'',
          Skip:0,
          Take:1,
          ...this.$route.query
        })
        if(res.IsSuccess){
          this.info = res.Result.Results[0]
        }
      }finally{
        this.pageloading = false
      }
    }
  }
